export default __webpack_public_path__ + "static/cover-big-bimp-d476102fc307dc1ceff31249e4b696af.png";